import PreferencesPaneSelectField from './PreferencesPaneSelectField';

export default PreferencesPaneSelectField;
export { PreferencesPaneSelectField };
